<template>
    <div
        class="flex flex-col -mt-6 sm:-mt-20"
        :class="isImpersonator ? 'h-[calc(100dvh-144px)]' : 'h-[calc(100dvh-80px)]'"
    >
        <message-hub-navbar v-if="!isMdShortHeight"></message-hub-navbar>

        <div class="flex h-full overflow-hidden gap-6 md:pb-3 md:px-6 md:pt-6 md:flex-row">
            <div class="flex flex-col grow lg:max-w-xl 2xl:max-w-2xl min-w-0" :class="sidebarClasses">
                <message-hub-navbar v-if="isMdShortHeight"></message-hub-navbar>
                <intelligent-inbox-sidebar v-if="isIntelligentRoute"></intelligent-inbox-sidebar>
                <message-hub-scheduled-messages-sidebar
                    v-else-if="isScheduledRoute"
                ></message-hub-scheduled-messages-sidebar>
                <message-hub-threads-sidebar v-else></message-hub-threads-sidebar>
            </div>

            <router-view
                class="grow"
                :class="[
                    isSidebarLanding ? 'hidden md:flex' : '',
                    route.name === 'message-hub.contact-view' ? 'md:w-2/3' : 'md:w-1/2',
                ]"
            ></router-view>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import MessageHubNavbar from '~/components/message-hub/MessageHubNavbar.vue';
import { useMessageHub } from '~/components/message-hub/useMessageHub';
import { useResponsiveLayout } from '~/composables/useResponsiveLayout';
import MessageHubThreadsSidebar from '~/components/message-hub/message-hub-threads/MessageHubThreadsSidebar.vue';
import MessageHubScheduledMessagesSidebar from '~/components/message-hub/message-hub-scheduled-messages/MessageHubScheduledMessagesSidebar.vue';
import IntelligentInboxSidebar from '~/components/message-hub/intelligent-inbox/IntelligentInboxSidebar.vue';

const route = useRoute();
const isImpersonator = Spark.isImpersonating;
const { isMdShortHeight } = useResponsiveLayout();

const { mountMessageHub, isScheduledRoute, isIntelligentRoute } = useMessageHub();

onMounted(() => {
    mountMessageHub();

    document.body.classList.add('overflow-hidden');
});

onUnmounted(() => {
    document.body.classList.remove('overflow-hidden');
});

const isSidebarLanding = computed(() => {
    return (
        route.name === 'message-hub' ||
        route.name === 'message-hub.scheduled-messages' ||
        route.name === 'message-hub.intelligent-inbox'
    );
});

const sidebarClasses = computed(() => {
    if (route.name === 'message-hub.contact-view') {
        return 'hidden lg:flex w-1/3';
    }

    return isSidebarLanding.value ? 'flex w-1/2' : 'hidden md:flex w-1/2';
});
</script>
